import { render, staticRenderFns } from "./editSysDict.vue?vue&type=template&id=57d24413&"
import script from "./editSysDict.vue?vue&type=script&lang=js&"
export * from "./editSysDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports